'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dConfig$002dPage$0024 from "./presto.-Config-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002495 from "./presto.-Presto-Router$$anon$95.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$94() {
  this.bqA = null;
  this.bqs = null;
  this.bqt = false;
  this.bqB = null;
  this.bqC = false;
  this.bqF = null;
  this.bqy = null;
  this.bqz = false;
  this.bqu = null;
  this.bqv = false;
  this.bqw = null;
  this.bqx = false;
  this.bqD = false;
  this.bqE = false;
  this.bqA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bqF = "ConfigPage";
}
export { $c_Lpresto_PrestoRouter$$anon$94 as $c_Lpresto_PrestoRouter$$anon$94 };
$p = $c_Lpresto_PrestoRouter$$anon$94.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$94;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$94() {
}
export { $h_Lpresto_PrestoRouter$$anon$94 as $h_Lpresto_PrestoRouter$$anon$94 };
$h_Lpresto_PrestoRouter$$anon$94.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bqA;
});
$p.M = (function() {
  if ((!this.bqt)) {
    this.bqs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bqt = true;
  }
  return this.bqs;
});
$p.O = (function() {
  if ((!this.bqC)) {
    this.bqB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bqC = true;
  }
  return this.bqB;
});
$p.D = (function() {
  return this.bqF;
});
$p.t = (function() {
  if ((!this.bqz)) {
    this.bqy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqz = true;
  }
  return this.bqy;
});
$p.N = (function() {
  if ((!this.bqv)) {
    this.bqu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bqv = true;
  }
  return this.bqu;
});
$p.Q = (function() {
  if ((!this.bqx)) {
    this.bqw = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002495.$c_Lpresto_PrestoRouter$$anon$95();
    this.bqx = true;
  }
  return this.bqw;
});
$p.v = (function() {
  if ((!this.bqE)) {
    this.bqD = false;
    this.bqE = true;
  }
  return this.bqD;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee590) => ((p) => \u03b4scrutinee590))($j_presto$002e$002dConfig$002dPage$0024.$m_Lpresto_ConfigPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$94 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$94, "presto.PrestoRouter$$anon$94", ({
  Pc: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$94 as $d_Lpresto_PrestoRouter$$anon$94 };
//# sourceMappingURL=presto.-Presto-Router$$anon$94.js.map
